export const CREATE_VIDEO = 'VIDEO/CREATE';
export const LOAD_VIDEOS = 'VIDEOS/LOAD';
export const DELETE_VIDEO = 'VIDEO/DELETE';
export const LOADING_STATUS = 'VIDEO/LOADING_STATUS';
